<template>
  <!-- Mobile Navigation (Bottom) -->
  <div class="md:hidden fixed bottom-0 left-0 right-0 bg-slate-50 border-t border-gray-200 rounded-full py-3 px-8 flex justify-between items-center z-10 nav-font">
    <router-link to="/" class="flex flex-col items-center" :class="{ 'active': currentRoute === 'home' }">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" :class="currentRoute === 'home' ? 'text-teal-600' : 'text-gray-400'" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    </router-link>
    <router-link to="/explore" class="flex flex-col items-center" :class="{ 'active': currentRoute === 'explore' }">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" :class="currentRoute === 'explore' ? 'text-teal-600' : 'text-gray-400'" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    </router-link>
    <router-link to="/map" class="flex flex-col items-center" :class="{ 'active': currentRoute === 'map' }">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" :class="currentRoute === 'map' ? 'text-teal-600' : 'text-gray-400'" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
      </svg>
    </router-link>
    <router-link to="/profile" class="flex flex-col items-center" :class="{ 'active': currentRoute === 'profile' }">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" :class="currentRoute === 'profile' ? 'text-teal-600' : 'text-gray-400'" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  props: {
    currentRoute: {
      type: String,
      default: 'home'
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;600&display=swap');

.nav-font {
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.active {
  font-weight: 600;
}

.router-link-active {
  position: relative;
}
</style>

